import { Component, Injector, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { MaterialService } from 'src/app/material/material.service';
import { BoxContainerService } from 'src/app/box-container/box-container.service';
import { MaterialCategoryEnum, ModifiersIdsEnum } from '../app-common-enum';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app-core/services/common.service';

@Component({
  selector: 'app-modifiers-structures',
  templateUrl: './modifiers-structures.component.html',
  styleUrls: ['./modifiers-structures.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ModifiersStructuresComponent extends AppComponentBase implements OnInit {
  @Input() set isDisabled(value: any) {
    this.isAllFieldsDisabled = value;
  }
  @ViewChild('modifiersForm', { static: false }) modifiersForm: NgForm;
  @Output() emitLoadContainerIds: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitModChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    injector: Injector,
    private boxContainerServices: BoxContainerService,
    private materialService: MaterialService,
    private router: Router,
    private commonService: CommonService,
    private route: ActivatedRoute) {
    super(injector);
    this.isMaterailList = (this.router.url.indexOf('/material-list') !== -1) ? true : false;
  }


  modifiersEnum: typeof ModifiersIdsEnum = ModifiersIdsEnum;
  materialCategoryEnum: typeof MaterialCategoryEnum = MaterialCategoryEnum;
  floaterContainerList: Array<any>;
  PalletContainerList: Array<any>;
  bottomDeckBoardContainerList: Array<any>;
  gussetsContainerList: Array<any>;
  skidOrientList: Array<any>;
  CleatsList: Array<any>;
  plywoodList: Array<any>;
  fullPerpendicularRubStripsContainerList: Array<any>;
  dropdownsObject: any = {};
  isStockContainer: boolean;
  isAllFieldsDisabled: boolean;
  isMaterailList = false;
  viewContainerId: string;

  ngOnInit() {
    if (this.router.url.indexOf('/box-container/box-container-details/') !== -1) {
      this.viewContainerId = this.route.snapshot.paramMap.get('containerId');
    }
    this.loadFloaterContainers();
    this.loadPalletContainers();
    this.loadBottomDeckoardContainers();
    this.loadGussetsContainers();
    this.loadFullPerpendicularRubStripsContainers();
    this.loadCleatsContainers();
    this.loadSkidOrientContainers();
    this.loadPlywoodContainers();
  }

  loadFloaterContainers() {
    let queryParam = `&StyleId=${this.modifiersEnum.floater}&IsActive=true`;
    queryParam += this.viewContainerId ? `&ContainerGuild=${this.viewContainerId}` : '';
    this.boxContainerServices.getBoxContainerLookups(queryParam).subscribe(response => {
      this.floaterContainerList = response.data;
    });
  }

  loadPalletContainers() {
    let queryParam = `&StyleId=${this.modifiersEnum.pallets}&IsActive=true`;
    queryParam += this.viewContainerId ? `&ContainerGuild=${this.viewContainerId}` : '';
    this.boxContainerServices.getBoxContainerLookups(queryParam)
      .subscribe(response => {
        this.PalletContainerList = response.data;
      });
  }

  loadBottomDeckoardContainers() {
    let queryParam = `&StyleId=${this.modifiersEnum.bottomDeckBoard}`;
    queryParam += this.viewContainerId ? `&ContainerGuild=${this.viewContainerId}` : '';
    this.boxContainerServices.getBoxContainerLookups(queryParam)
      .subscribe(response => {
        this.bottomDeckBoardContainerList = response.data;
      });
  }

  loadGussetsContainers() {
    let queryParam = `&StyleId=${this.modifiersEnum.gussets}&IsActive=true`;
    queryParam += this.viewContainerId ? `&ContainerGuild=${this.viewContainerId}` : '';
    this.boxContainerServices.getBoxContainerLookups(queryParam).subscribe(response => {
      this.gussetsContainerList = response.data;
    });
  }

  loadFullPerpendicularRubStripsContainers() {
    let queryParam = `&StyleId=${this.modifiersEnum.fullPerpendicularRubStrips}&IsActive=true`;
    queryParam += this.viewContainerId ? `&ContainerGuild=${this.viewContainerId}` : '';
    this.boxContainerServices.getBoxContainerLookups(queryParam)
      .subscribe(response => {
        this.fullPerpendicularRubStripsContainerList = response.data;
      });
  }

  loadCleatsContainers() {
    this.commonService.getCleatsList(`&materialCategoryId=1`).subscribe(response => {
      this.CleatsList = response.data;
    });
  }

  loadSkidOrientContainers() {
    this.boxContainerServices.getSkidOrientContainersLookups().subscribe(response => {
      this.skidOrientList = response.data;
    });
  }

  loadPlywoodContainers() {
    this.commonService.getCleatsList(`&materialCategoryId=2`).subscribe(response => {
      this.plywoodList = response.data;
    });
  }

  onPalletChange(item: any) {
    if (item) {
      this.dropdownsObject.palletId = item.containerId;
      this.dropdownsObject.palletParentContainerId = item.parentContainerId;
      this.dropdownsObject.palletName = item.containerName;
      this.dropdownsObject.palletTemplateContainerId = item.templateContainerId;
    } else {
      this.dropdownsObject.palletId = null;
      this.dropdownsObject.palletParentContainerId = null;
      this.dropdownsObject.palletName = null;
      this.dropdownsObject.palletTemplateContainerId = null;
    }

    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }

  onBottomDeckBoardChange(item: any) {
    if (item) {
      this.dropdownsObject.bottomDeckBoardId = item.containerId;
      this.dropdownsObject.bottomDeckBoardParentContainerId = item.parentContainerId;
      this.dropdownsObject.bottomDeckBoardName = item.containerName;
      this.dropdownsObject.bottomDeckBoardTemplateContainerId = item.templateContainerId;
    } else {
      this.dropdownsObject.bottomDeckBoardId = null;
      this.dropdownsObject.bottomDeckBoardParentContainerId = null;
      this.dropdownsObject.bottomDeckBoardName = null;
      this.dropdownsObject.bottomDeckBoardTemplateContainerId = null;
    }
    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }

  onGussetChange(item: any) {
    if (item) {
      this.dropdownsObject.gussetsId = item.containerId;
      this.dropdownsObject.gussetsParentContainerId = item.parentContainerId;
      this.dropdownsObject.gussetsName = item.containerName;
      this.dropdownsObject.gussetsTemplateContainerId = item.templateContainerId;
    } else {
      this.dropdownsObject.gussetsId = null;
      this.dropdownsObject.gussetsParentContainerId = null;
      this.dropdownsObject.gussetsName = null;
      this.dropdownsObject.gussetsTemplateContainerId = null;
    }

    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }

  onRubstripsChange(item: any) {
    if (item) {
      this.dropdownsObject.fullPerpendicularRubStripsId = item.containerId;
      this.dropdownsObject.fullPerpendicularRubStripsParentContainerId = item.parentContainerId;
      this.dropdownsObject.fullPerpendicularRubStripsName = item.containerName;
      this.dropdownsObject.fullPerpendicularRubStripsTemplateContainerId = item.templateContainerId;
    } else {
      this.dropdownsObject.fullPerpendicularRubStripsId = null;
      this.dropdownsObject.fullPerpendicularRubStripsParentContainerId = null;
      this.dropdownsObject.fullPerpendicularRubStripsName = null;
      this.dropdownsObject.fullPerpendicularRubStripsTemplateContainerId = null;
    }
    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }

  onfloaterChange(item: any) {
    if (item) {
      this.dropdownsObject.floaterId = item.containerId;
      this.dropdownsObject.floaterParentContainerId = item.parentContainerId;
      this.dropdownsObject.floaterName = item.containerName;
      this.dropdownsObject.floaterTemplateContainerId = item.templateContainerId;
    } else {
      this.dropdownsObject.floaterId = null;
      this.dropdownsObject.floaterParentContainerId = null;
      this.dropdownsObject.floaterName = null;
      this.dropdownsObject.floaterTemplateContainerId = null;
    }

    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }

  onSkidOrientIdChange(event: any) {
    this.dropdownsObject.skidOrientId = event.id;
    this.dropdownsObject.SkidOrientName = event.materialName;
    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }

  onCleatsIdChange(event: any) {
    if (event.id) {
      this.dropdownsObject.cleatsId = event.id;
      this.dropdownsObject.cleatName = event.materialName;
    }
    this.modifiersForm.form.markAsDirty();
    this.emitModChange.emit(this.materialCategoryEnum.lumber);
  }

  onPlywoodChange(event: any) {
    if (event.id) {
      this.dropdownsObject.plywoodId = event.id;
      this.dropdownsObject.plywoodName = event.materialName;
    }
    this.modifiersForm.form.markAsDirty();
    this.emitModChange.emit(this.materialCategoryEnum.plywood);
  }

  onSpecificNoteChange() {
    this.modifiersForm.form.markAsDirty();
    this.emitLoadContainerIds.emit();
  }
}
